<h3 class="title">{{ 'pipeline_editor.steps.title' | translate }}</h3>
<p class="description">{{ 'pipeline_editor.steps.description' | translate }}</p>

<div class="loading-state" *ngIf="loading" data-cy="step-loading">
  <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
</div>

<div class="empty-state" *ngIf="!loading && items.length === 0" data-cy="step-empty">
  {{ 'pipeline_editor.steps.empty' | translate }}
</div>

<ul class="list" *ngIf="!loading && items.length > 0">
  <li
    class="pack"
    *ngFor="let pack of packs; trackBy: trackByPackOrder"
    [class.pack--zone-on]="isPackZoneActive(pack)"
    data-cy="step-pack"
  >
    <div class="pack__rows">
      <div
        class="row"
        *ngFor="let item of pack.items; trackBy: trackByUuid"
        [attr.draggable]="!disabled && pendingRemovalUuid === null"
        (dragstart)="onDragStart(item, $event)"
        (dragover)="onDragOver(item, $event)"
        (drop)="onDrop(item, $event)"
        (dragend)="onDragEnd()"
        [class.row--zone-above]="isZoneActive(item, 'above')"
        [class.row--zone-below]="isZoneActive(item, 'below')"
        [class.row--dragging]="draggedUuid === item.uuid"
        [class.row--disabled]="disabled"
        [attr.data-cy]="'step-row'"
      >
        <span class="row__number">
          {{ 'pipeline_editor.steps.step_number' | translate: { order: pack.order + 1 } }}
        </span>
        <span class="row__task">
          [{{ ('pipeline_editor.steps.task.' + item.task) | translate }}]
        </span>

        <span class="row__confirm-text" *ngIf="pendingRemovalUuid === item.uuid">
          {{ 'pipeline_editor.steps.confirm_delete' | translate }}
        </span>

        <ng-container *ngIf="pendingRemovalUuid !== item.uuid; else confirmActionsTpl">
          <ng-container *ngIf="!disabled; else readOnlyActionsTpl">
            <span class="row__actions">
              <button
                type="button"
                class="icon-button"
                (click)="editClicked.emit(item)"
                data-cy="step-edit"
              >
                <i class="ri-pencil-line"></i>
              </button>
              <button
                type="button"
                class="icon-button icon-button--danger"
                (click)="requestRemove(item)"
                data-cy="step-remove"
              >
                <i class="ri-close-line"></i>
              </button>
            </span>
          </ng-container>
          <ng-template #readOnlyActionsTpl>
            <span class="row__actions">
              <button
                type="button"
                class="icon-button"
                (click)="visualizeClicked.emit(item)"
                data-cy="step-visualize"
              >
                <i class="ri-eye-line"></i>
              </button>
            </span>
          </ng-template>
        </ng-container>

        <ng-template #confirmActionsTpl>
          <span class="row__actions">
            <button
              type="button"
              class="btn btn-flat"
              (click)="cancelRemove()"
              data-cy="step-remove-cancel"
            >
              {{ 'button.cancel' | translate }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              (click)="confirmRemove(item)"
              data-cy="step-remove-confirm"
            >
              {{ 'button.confirm' | translate }}
            </button>
          </span>
        </ng-template>
      </div>
    </div>
  </li>
</ul>

<button
  *ngIf="!loading && !disabled"
  type="button"
  class="btn btn-primary add-button"
  (click)="addClicked.emit()"
  data-cy="step-add"
>
  <i class="ri-add-circle-line"></i>
  {{ 'pipeline_editor.steps.add_button' | translate }}
</button>
